const slides = [
    {
        carouselImage: '/images/CarouselImage/ApesTN3.png',
        backgroundImages: [
            '/images/BackgroundImage/Apes/enhanced/101.png',
            '/images/BackgroundImage/Apes/enhanced/103.png',
            '/images/BackgroundImage/Apes/enhanced/46.png',
        ],
        videoId: '5Yt_kizLWkE', // 5Yt_kizLWkE one with intro Yfu5FBi0tLE
        title: 'Rebellion of the Apes - Final Trailer',
        titleImage: '/images/TitleImages/ApeTitle.png',
        description: 'The apes return in a remastered spectacle, more intense and immersive than ever. Experience the uprising through enhanced visuals and gripping new sequences. This is the definitive version of the apes’ fight for freedom.',
        genre: ['Action', 'Adventure', 'War'],
        type: 'trailer',
        year: 2025,
    },
    {
        carouselImage: '/images/CarouselImage/SharkTN.png',
        backgroundImages: [
            '/images/BackgroundImage/Shark/enhanced/1.png',
            '/images/BackgroundImage/Shark/enhanced/2.png',
            '/images/BackgroundImage/Shark/enhanced/3.png',
            '/images/BackgroundImage/Shark/enhanced/5.png',
            '/images/BackgroundImage/Shark/enhanced/6.png',
            '/images/BackgroundImage/Shark/enhanced/8.png',
            '/images/BackgroundImage/Shark/enhanced/11.png',
            '/images/BackgroundImage/Shark/enhanced/12.png',
        ],
        videoId: 'qjIj3KANvVQ',
        title: 'Shark King - Trailer',
        titleImage: '/images/TitleImages/SharkTitle.png',
        description: `Beneath the waves, a brutal force is rising. The ocean's deadliest predators now set their sights on land, claiming territory and terror. Shark King unleashes the fury of the sea in an unstoppable march toward domination.`,
        genre: ['Action', 'Thriller', 'War'],
        type: 'trailer',
        year: 2024,

    },
    {
        carouselImage: '/images/CarouselImage/ApesTN1.png',
        backgroundImages: [
            '/images/BackgroundImage/Apes/enhanced/4.png',
            '/images/BackgroundImage/Apes/enhanced/5.png',
            '/images/BackgroundImage/Apes/enhanced/6.png',
            '/images/BackgroundImage/Apes/enhanced/9.png',
        ],
        videoId: 'ijJ5bAnoeUQ',
        title: 'Rebellion of the Apes - First Trailer',
        titleImage: '/images/TitleImages/ApeTitle.png',
        description: 'Witness the birth of revolution as oppressed apes rise against their human overlords. With intelligence, strategy, and sheer force, they ignite a war for their future. This is where the rebellion begins — fierce, raw, and unforgettable.',
        genre: ['Action', 'Adventure', 'War'],
        type: 'trailer',
        year: 2024,
    },

    {
        carouselImage: '/images/CarouselImage/RabbitsTN.png',
        backgroundImages: [
            '/images/BackgroundImage/Rabbits/enhanced/1.png',
            '/images/BackgroundImage/Rabbits/enhanced/2.png',
        ],
        videoId: 'NFTEyd1HWIo',
        title: 'Rabid Waltz',
        titleImage: '/images/TitleImages/rabbitsTitle.png',
        description: 'Step into a surreal world where rabbits perform a hauntingly bizarre ballet. With each synchronized hop and twist, madness unfolds in rhythmic beauty. Rabid Waltz is a darkly whimsical journey through dance, disorder, and dreams.',
        genre: ['Comedy', 'Musical'],
        type: 'film',
        year: 2024,
    },

    {
        carouselImage: '/images/CarouselImage/CarnivalTN.png',
        backgroundImages: [
            '/images/BackgroundImage/Carnival/enhanced/10.png',
            '/images/BackgroundImage/Carnival/enhanced/11.png',
            '/images/BackgroundImage/Carnival/enhanced/13.png',
            '/images/BackgroundImage/Carnival/enhanced/16.png',
            '/images/BackgroundImage/Carnival/enhanced/22.png',
        ],
        videoId: 'Z_uyHEy52EY',
        title: 'The Carnival',
        titleImage: '/images/TitleImages/carnivalTitle.png',
        description: 'An abandoned carnival hides secrets darker than its shadows. As visitors wander deeper, they find themselves trapped in a game of fear and illusion. ‘The Carnival’ lures you in with wonder — and refuses to let you leave.',
        genre: ['Horror', 'Adventure', 'Thriller'],
        type: 'film',
        year: 2023,
    },
    {
        carouselImage: '/images/CarouselImage/DogDreamTN.png',
        backgroundImages: [
            '/images/BackgroundImage/DogDream/enhanced/1.png',
            '/images/BackgroundImage/DogDream/enhanced/6.png',
            '/images/BackgroundImage/DogDream/enhanced/9.png',
        ],
        videoId: 'W7t2P9uV-vc',
        title: 'Pawfect Hybrids',
        titleImage: '/images/TitleImages/dogTitle.png',
        description: `A little girl's imagination brings to life fantastical dog-creatures like no other. Part dream, part mutation — they leap from her mind into a world of joy and chaos. Pawfect Hybrids is a heartfelt and surreal tale of childhood wonder unleashed.`,
        genre: ['Family', 'Fantasy'],
        type: 'film',
        year: 2023,
    },
    {
        carouselImage: '/images/CarouselImage/ClownTherapyTN2.png',
        backgroundImages: [
            '/images/BackgroundImage/ClownTherapy/enhanced/15.png',
            '/images/BackgroundImage/ClownTherapy/enhanced/4.png',
        ],
        videoId: 'dgknJilh05k',
        title: 'Clown Therapy - Trailer',
        titleImage: '/images/TitleImages/clownTherapyTitle.png',
        description: 'The clowns are back for another session — and this time, no one is safe. What begins as therapy quickly spirals into chaos, with twisted laughs and terrifying truths. Clown Therapy II drags you back into a circus of psychological horror.',
        genre: ['Horror', 'Thriller'],
        type: 'trailer',
        year: 2024,
    },
    {
        carouselImage: '/images/CarouselImage/SpaceTN.png',
        backgroundImages: [
            '/images/BackgroundImage/Space/enhanced/16.png',
        ],
        videoId: '1fhfapBRGu4',
        title: 'Gravity’s Paw',
        titleImage: '/images/TitleImages/spaceTitle.png',
        description: 'When animals are launched into orbit, the laws of nature no longer apply. Strange phenomena and deep space instincts collide in zero gravity. Gravity’s Paw redefines survival — where paws meet the stars.',
        genre: ['Action', 'Horror', 'Sci-Fi'],
        type: 'film',
        year: 2024,
    },
    {
        carouselImage: '/images/CarouselImage/MarvelTN.png',
        backgroundImages: [
            '/images/BackgroundImage/Marvel/enhanced/10.png',
            '/images/BackgroundImage/Marvel/enhanced/12.png',
            '/images/BackgroundImage/Marvel/enhanced/15.png',
            '/images/BackgroundImage/Marvel/enhanced/25.png',
            '/images/BackgroundImage/Marvel/enhanced/28.png',
        ],
        videoId: '0RHcBoY4z44',
        title: 'Marvel Fusion',
        titleImage: '/images/TitleImages/marvelTitle.png',
        description: `In an experimental collision of timelines, Marvel's greatest heroes unite like never before. Their combined powers unleash a force that transcends the multiverse. Marvel Fusion is a bold reimagining of legacy, unity, and the chaos of convergence.`,
        genre: ['Action', 'Sci-Fi', 'Experimental'],
        type: 'film',
        year: 2024,
    },
    {
        carouselImage: '/images/CarouselImage/ApesTN2.png',
        backgroundImages: [
            '/images/BackgroundImage/Apes/enhanced/15.png',
            '/images/BackgroundImage/Apes/enhanced/40.png',
            '/images/BackgroundImage/Apes/enhanced/41.png',
        ],
        videoId: 'Kxy6B6d4h6Y',
        title: 'Rebellion of the Apes - Second Trailer',
        titleImage: '/images/TitleImages/ApeTitle.png',
        description: `Rival ape clans clash in the aftermath of rebellion, each vying for dominance.
The stakes are higher, the battles more brutal, and the future uncertain.`,
        genre: ['Action', 'Adventure', 'War'],
        type: 'trailer',
        year: 2024,
    },
    {
        carouselImage: '/images/CarouselImage/ClownTherapyTN.png',
        backgroundImages: [
            '/images/BackgroundImage/ClownTherapy/enhanced/13.png',
        ],
        videoId: '-uH6-Z3mFUA',
        title: 'Clown Therapy',
        titleImage: '/images/TitleImages/clownTherapyTitle.png',
        description: 'In a small room with a single chair, a patient meets the strangest therapist of all. The session begins with laughter, but ends in something far more chilling. Clown Therapy explores the thin line between comedy and horror — and crosses it.',
        genre: ['Horror', 'Thriller'],
        type: 'film',
        year: 2024,

    },
    {
        carouselImage: '/images/CarouselImage/DreamTN.png',
        backgroundImages: [
            '/images/BackgroundImage/Dream/1.png',
            '/images/BackgroundImage/Dream/toes1.png',
        ],
        videoId: 'ihc4vQ_Nb18',
        title: 'Worlds of Wonder',
        titleImage: '/images/TitleImages/dreamTitle.png',
        description: 'Enter a kaleidoscopic dreamworld where logic fades and imagination reigns. Each turn reveals a new realm, more dazzling and surreal than the last. Worlds of Wonder invites you to get lost in the beauty of limitless possibility.',
        genre: ['Adventure', 'Fantasy'],
        type: 'film',
        year: 2024,
    },
];

export default slides;